import React from 'react';
import { Icon } from './Icon.js';
export const IconBooleanUnion = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 3H3V16H8V21L21 21V8H16V3Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBooleanUnion.js.map